module.exports = "../images/fishing-hero.jpg?v=048723f";